import { createSelector } from 'reselect';
export const projectConfigSelector = (state) => state.projectConfig;
export const contractTypesSelector = createSelector(projectConfigSelector, (projectConfig) => {
    return projectConfig.data.CONTRACT_TYPES;
});
